import { stat } from 'fs';
import moment from 'moment';
import { IPost } from '../../../services/interfaces';
import {
  SET_LINK_URL,
  SET_POSTS,
  SET_POST_GROUP,
  SET_POST_STATUS,
  SET_POST_TAGS,
  SET_POST_TITLE,
  SET_SELECTED_POST,
  SET_SELECTED_POST_DATE,
  SET_POST_CONTENT,
  UPDATE_POST_LIST,
  UPDATE_POST_LIST_CONFIG,
  SET_POST_NOTE,
  SET_POST_HIGHLIGHTS,
  UPDATE_POST_HIGHLIGHT,
  DELETE_HIGHLIGHT,
  SET_POSTS_HIGHLIGHTS, SET_POST_TAGS_LIST,
} from '../../constants';

import { IReduxAction } from '../../interfaces';

export interface IPostListConfig {
  search: string;
  filter: string;
  tags: string;
  sort: string;
  pagination: {
    limit: number,
    lastItem: object | null,
  };
}

interface IPostState {
  list: object[];
  selected: IPost | null;
  listConfig: IPostListConfig;
}

const initState: IPostState = {
  list: [],
  selected: null,
  listConfig: {
    search: '',
    filter: 'all',
    tags: 'all',
    sort: 'date-descend',
    pagination: {
      limit: 25,
      lastItem: null,
    },
  },
};

export function postReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case SET_POSTS:
      return {
        ...state,
        list: action.payload,
      };

    case SET_POST_TAGS_LIST:
      return {
        ...state,
        tags: action.payload,
      };

    case SET_POSTS_HIGHLIGHTS:
      return {
        ...state,
        list: state
          .list.map((item: any) => {
            return item.id === action.payload.postId ? ({
              ...item,
              highlights: action.payload.highlights,
            }) : item;
          }),
      };

    case SET_SELECTED_POST:
      return {
        ...state,
        selected: action.payload,
      };

    case UPDATE_POST_LIST_CONFIG:
      return {
        ...state,
        listConfig: action.payload,
      };

    case UPDATE_POST_LIST:
      const currDate = new Date();
      const updatedPostArray = state
        .list.map((item: any) => {

          return item.id === action.payload.id ? ({
            ...action.payload,
            date: moment(action.payload.date).format('MM/DD/YYYY'),
            updated: moment(currDate.toUTCString()).format('MM/DD/YYYY HH:mm:ss ZZ'),
          }) : item;
        });

      return {
        ...state,
        list: [
          ...updatedPostArray,
        ],
        selected: {
          ...state.selected,
          updated: moment(currDate.toUTCString()).format('MM/DD/YYYY HH:mm:ss ZZ'),
        },
      };

    case SET_SELECTED_POST_DATE:
      return {
        ...state,
        selected: {
          ...state.selected,
          date: action.payload.date,
        },
      };

    case SET_POST_TITLE:
      return {
        ...state,
        selected: {
          ...state.selected,
          title: action.payload.title,
        },
      };

    case SET_LINK_URL:
      return {
        ...state,
        selected: {
          ...state.selected,
          linkUrl: action.payload.linkUrl,
        },
      };

    case SET_POST_TAGS:
      return {
        ...state,
        selected: {
          ...state.selected,
          tags: action.payload.tags,
        },
      };

    case SET_POST_GROUP:
      return {
        ...state,
        selected: {
          ...state.selected,
          group: action.payload.group,
          public: action.payload.group?.type === 'Public',
        },
      };

    case SET_POST_STATUS:
      return {
        ...state,
        selected: {
          ...state.selected,
          posted: action.payload.posted,
        },
      };

    case SET_POST_CONTENT:
      return {
        ...state,
        selected: {
          ...state.selected,
          content: action.payload.content,
        },
      };

    case SET_POST_HIGHLIGHTS:
      const listHighlighUpdate = state.list.map((item: any) => {
        return item.id === state.selected?.id
          ? {
            ...item,
            highlights: action.payload.highlights,
          }
          : item;
      });

      return {
        ...state,
        list: [
          ...listHighlighUpdate,
        ],
        selected: {
          ...state.selected,
          highlights: action.payload.highlights,
        },
      };

    case SET_POST_NOTE:
      return {
        ...state,
        selected: {
          ...state.selected,
          note: action.payload.note,
        },
      };

    case UPDATE_POST_HIGHLIGHT:
      const highlights = !state.selected?.highlights
        ? []
        : state.selected.highlights;

      const updatedHighlights = highlights
        .map(item => item.id === action.payload.id
          ? action.payload
          : item);

      const listHighlightUpdate = state.list.map((item: any) => {
        return item.id === state.selected?.id
          ? {
            ...item,
            highlights: [
              ...updatedHighlights,
            ],
          }
          : item;
      });

      return {
        ...state,
        list: [
          ...listHighlightUpdate,
        ],
        selected: {
          ...state.selected,
          highlights: [
            ...updatedHighlights,
          ],
        },
      };

    case DELETE_HIGHLIGHT:
      const deletedHighlightsUpdate =
        state.selected?.highlights?.filter(item => item.id !== action.payload);

      return {
        ...state,
        list: state.list.map((item: any) => {
          return item.id === state.selected?.id
            ? {
              ...item,
              highlights: deletedHighlightsUpdate,
            }
            : item;
        }),
        selected: {
          ...state.selected,
          highlights: deletedHighlightsUpdate,
        },
      };

    default:
      return state;
  }
}
